import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";

const About = lazy(() => import("@/pages/About"));
const Prestations = lazy(() => import("@/pages/Prestations"));
const Prestation = lazy(() => import("@/pages/Prestation"));
const Entreprises = lazy(() => import("@/pages/Entreprises"));
const Tarifs = lazy(() => import("@/pages/Tarifs"));
const Contact = lazy(() => import("@/pages/Contact"));
const FAQ = lazy(() => import("@/pages/FAQ"));
const Mentions = lazy(() => import("@/pages/Mentions"));
const Guides = lazy(() => import("@/pages/Guides"));
const Guide = lazy(() => import("@/pages/Guide"));
const Proximite = lazy(() => import("@/pages/Proximite"));
const Zone = lazy(() => import("@/pages/Zone"));
const PremiereSeance = lazy(() => import("@/pages/PremiereSeance"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function PageFallback() {
    return (
        <div
            className="min-h-[40vh] grid place-items-center text-brown-soft text-sm"
            aria-busy="true"
            aria-live="polite"
        >
            Chargement…
        </div>
    );
}

export default function App() {
    return (
        <HelmetProvider>
            <BrowserRouter>
                <Layout>
                    <Suspense fallback={<PageFallback />}>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/a-propos" element={<About />} />
                            <Route path="/prestations" element={<Prestations />} />
                            <Route
                                path="/prestations/:slug"
                                element={<Prestation />}
                            />
                            <Route path="/entreprises" element={<Entreprises />} />
                            <Route path="/tarifs" element={<Tarifs />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/faq" element={<FAQ />} />
                            <Route
                                path="/premiere-seance"
                                element={<PremiereSeance />}
                            />
                            <Route path="/guides" element={<Guides />} />
                            <Route path="/guides/:slug" element={<Guide />} />
                            <Route path="/proximite" element={<Proximite />} />
                            <Route path="/proximite/:slug" element={<Zone />} />
                            <Route path="/mentions-legales" element={<Mentions />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </Suspense>
                </Layout>
            </BrowserRouter>
        </HelmetProvider>
    );
}
